<template>
  <div>
    <p class="contentCode" v-html="content" />
  </div>
</template>

<script>
let timer;
import { severTime } from '@/http/index'
import { getExamTimestamp } from '@/utils/index'
export default {
  name: 'CountDown',
  props: { // 接收父组件的数据
    endTime: { type: String, default: '' },
    endText: { type: String, default: '' }
  },
  data() {
    return {
      content: '',
      nowTime: ''
    }
  },
  watch: { // 监听时间的变化
    'endTime': {
      handler(val) {
        clearInterval(this.timer);
        severTime().then(res => {
          this.nowTime =  res.data.sever_time
          this.countdowm(val)
        })
      },
      deep: true,
      immediate: true
    }
  },
  beforeDestroy() {
    clearInterval();
  },
  methods: {
    // 考试结束
    endCount() {
      console.log('考试结束')
      clearInterval(this.timer);
      this.content = this.endText;
    },
    async countdowm(timestamp) {
      const self = this;
      const nowTimestamp = getExamTimestamp(this.nowTime)
      const endTimestamp = Number(timestamp) * 1000
      if (!Number.isFinite(nowTimestamp) || !Number.isFinite(endTimestamp)) {
        clearInterval(this.timer)
        this.content = ''
        return
      }
      let t = endTimestamp - nowTimestamp;
      this.timer = setInterval(function() {
        if (t > 0) {
          const day = Math.floor(t / 86400000);
          let hour = Math.floor((t / 3600000) % 24);
          let min = Math.floor((t / 60000) % 60);
          let sec = Math.floor((t / 1000) % 60);
          hour = hour < 10 ? "0" + hour : hour;
          min = min < 10 ? "0" + min : min;
          sec = sec < 10 ? "0" + sec : sec;
          let format = '';
          if (day > 0) {
            format = `<span>${day}</span>天<span>${hour}</span>小时<span>${min}</span>分<span>${sec}</span>秒`;
          }
          if (day <= 0 && hour > 0) {
            format = `<span>${hour}</span>小时<span>${min}</span>分<span>${sec}</span>秒`;
          }
          if (day <= 0 && hour <= 0) {
            format = `<span>${min}</span>分<span>${sec}</span>秒`;
          }
          self.content = format;
          t -= 1000
        } else {
          clearInterval(self.timer);
          self.$emit('countEnd')
          self.content = self.endText;
        }
      }, 1000);
    }
  }
}
</script>
<style>
.contentCode {
    display: flex;
    align-items: center;
    flex: 2;
    font-size: 16px;
    color: #5FCA71;
    justify-content: center;
}

.contentCode span {
    /* background-color: #F5BC41; */
    color: #5FCA71;
    font-size: 16px;
    /* width: 20px; */
    padding: 0 4px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    margin: 0 3px;
    border-radius: 2px;
}
</style>
